<!--
 * @Description:
-->
<template>
  <el-popover placement="right" trigger="hover">
    <!-- <el-button slot="reference">项目统计</el-button> -->
    <div id="table">
      <el-table
        border
        header-row-class-name="tableHeader"
        :data="currentData"
        style="width: 100%"
        :fit="true"
      >
        <el-table-column
          header-align="center"
          prop="projectName"
          label="项目名称"
          width="240"
        ></el-table-column>
        <el-table-column header-align="center" label="金额">
          <template slot-scope="{ row }">
            <p>{{ row.totalPrice || 0 }}元</p>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="peopleCount"
          label="支付人数"
        ></el-table-column>
      </el-table>
      <el-pagination
        small
        layout="prev, pager, next"
        :total="tableData.length"
        :current-page.sync="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <div
      slot="reference"
      style="margin-left:10px;background-color:#FF6600;padding:0;height:30px;padding:0 5px;line-height:30px;color:#FFFFFF;border-radius:3px"
    >
      项目统计
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'projectStatistics',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    totalProjectByIds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentPage: 1,
      currentData: [],
      total: 0,
      pageSize: 5,
      formatTableData: []
    };
  },
  watch: {
    tableData: {
      deep: true,
      immediate: true,
      handler(v) {
        // const result = {};
        // v.forEach(item => {
        //   if (result[item.projectId]) {
        //     result[item.projectId].totalPrice += +item.totalPrice;
        //     result[item.projectId].peopleCount++;
        //   } else {
        //     result[item.projectId] = {
        //       totalPrice: +item.totalPrice,
        //       peopleCount: 1,
        //       projectName: item.projectName
        //     };
        //   }
        // });
        // let returnArray = [];
        // for (const key in result) {
        //   returnArray.push(result[key]);
        // }
        // this.formatTableData = [...returnArray];
        // this.currentData = this.formatTableData.slice(0, this.pageSize);
        this.currentData = v.slice(0, this.pageSize);
      }
    },
    // 获取当前页数据
    currentPage(v) {
      this.currentData = this.tableData.slice(
        (v - 1) * this.pageSize,
        this.pageSize * v
      );
    }
    // formatTableData变化后初始对应数据
    // formatTableData: {
    //   handler(v) {
    //     this.currentPage = 1;
    //     this.total = v.length;
    //     this.currentData = v.slice(this.currentPage - 1, this.pageSize);
    //   },
    //   immediate: true
    // }
  }
};
</script>

<style lang="scss">
.tableHeader th {
  // color: red !important;
  font-weight: 800;
  background-color: #fbfbfb !important;
}
</style>
